import React, { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';

const LlamaFarmConfigModal = lazy(
  () => import(/* webpackChunkName: "owner" */ '../LlamaFarmConfigModal')
);

type Props = any;

const LlamaFarmConfigModalLazy: React.FC<Props> = props => {
  return (
    <Suspense fallback={<WidgetConfigPopover isLoading onClose={() => null} />}>
      <LlamaFarmConfigModal {...props} />
    </Suspense>
  );
};
LlamaFarmConfigModalLazy.displayName = 'LlamaFarmConfigModalLazy';

export default LlamaFarmConfigModalLazy;
